import { Day, PaginatedSchedulerRow } from "./../../types/global";
import { canvasWrapperId } from "./../../constants";
import { Theme } from "./../../styles";
import { drawMonthlyView } from "./drawMonthlyView";
import { drawYearlyView } from "./drawYearlyView";
import { drawHourlyView } from "./drawHourlyView";
import { drawYearlyMonthView } from "./drawYearlyMonthView";
import { IHoliday } from "../../../@types/holiday.type";
import { drawBlockedCells } from "./drawBlockedCells";

export const drawGrid = (
  ctx: CanvasRenderingContext2D,
  zoom: number,
  rows: number,
  cols: number,
  parsedStartDate: Day,
  theme: Theme,
  listHolidays: IHoliday[],
  data: PaginatedSchedulerRow[]
) => {

  ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
  const canvasWrapper = document.getElementById(canvasWrapperId);
  if (!canvasWrapper) return;
  switch (zoom) {
    case 0:
    case 3:
      drawYearlyView(ctx, rows, cols, parsedStartDate, theme);
      break;
    case 4:
      drawYearlyMonthView(ctx, rows, cols, parsedStartDate, theme);
      break;
    case 1:
      drawMonthlyView(ctx, rows, cols, parsedStartDate, theme, listHolidays);
      break;
    case 2:
      drawHourlyView(ctx, rows, cols, parsedStartDate, theme);
      break;
  }
  if (data && data.length > 0) {
    drawBlockedCells(ctx, zoom, rows, cols, parsedStartDate, data);
  }
};
